import React, { useMemo, useState } from 'react';

import { SearchBar, Spinner } from '@components';
import SegmentedControl from '@components/segmented-control/SegmentedControl';

import LeadStatusSummaryTable from './LeadStatusSummaryTable';

import { leadDashabordTabFiltersOptions } from '../../constants';
import {
  LeadStatusSummaryRow,
  LeadSummaryTab
} from '../../types/leadAnalytics';

interface AgentsDistributionCardProps {
  rows: LeadStatusSummaryRow[];
  statusList: { id: string; name: string; color: string }[];
  isLoading?: boolean;
}

const AgentsDistributionCard: React.FC<AgentsDistributionCardProps> = ({
  rows,
  statusList,
  isLoading = false
}) => {
  const [appliedTab, setAppliedTab] = useState(LeadSummaryTab.COUNT);
  const [search, setSearch] = useState('');

  const filteredRows = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return rows;
    return rows.filter((row) =>
      (row.label?.toLowerCase() || '').includes(term)
    );
  }, [rows, search]);

  return (
    <div className="flex w-full flex-col gap-4 rounded-xl border border-grey10 bg-white p-6 shadow-md">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="text-20 font-semibold text-content">
          Leads Distribution By Agents
        </div>
        <SegmentedControl
          options={leadDashabordTabFiltersOptions}
          selectedId={appliedTab}
          onChange={(option) => setAppliedTab(option.id as LeadSummaryTab)}
        />
      </div>
      <SearchBar
        placeholder="Search"
        value={search}
        onSearch={setSearch}
        searchBarStyle="!w-full max-w-md"
      />
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center py-20">
          <Spinner />
        </div>
      ) : (
        <LeadStatusSummaryTable
          rows={filteredRows}
          statusList={statusList}
          appliedTab={appliedTab}
        />
      )}
    </div>
  );
};

export default AgentsDistributionCard;
